<app-header [isLogged]="false"></app-header>

<app-header-banner class="profile-header"></app-header-banner>

<main class="container">
  <app-view-unlogged></app-view-unlogged>
</main>

<app-footer></app-footer>
